import React, { useState } from "react";
import "./Finagg.css";
import { CircleMinus, CirclePlus } from "tabler-icons-react";

export default function FinaagInputChange({
  serviceName,
  serviceUrls,
  setServiceUrls,
}: any) {
  const [editableFields, setEditableFields] = useState<{ [key: string]: any }>(
    serviceUrls[serviceName]
  );

  const [newKey, setNewKey] = useState("");

  // const handleChangeForServiceUrls = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   fieldName: string
  // ) => {
  //   let value = e.target.value;
  //   const updatedValue = { ...editableFields, [fieldName]: value };
  //   setEditableFields((prevState: any) => ({ ...prevState, ...updatedValue }));
  //   serviceUrls[serviceName] = updatedValue;
  //   setServiceUrls(serviceUrls);
  // };

  const handleChangeForServiceUrls = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string
  ) => {
    const { value } = e.target;
    const updatedValue = { ...editableFields, [fieldName]: value };
    setEditableFields(updatedValue);

    setServiceUrls((prevState: any) => ({
      ...prevState,
      [serviceName]: updatedValue,
    }));
  };

  const handleAddNewDiv = () => {
    if (newKey !== "") {
      const newServiceUrls = {
        ...serviceUrls,
        [serviceName]: {
          ...editableFields,
          [newKey]: "",
        },
      };

      setServiceUrls(newServiceUrls);
      setNewKey("");
    }
  };

  const handleDeleteRow = (key: string) => {
    const { [key]: deletedField, ...updatedFields } = editableFields;
    const newServiceUrls = {
      ...serviceUrls,
      [serviceName]: updatedFields,
    };

    setEditableFields(updatedFields);
    setServiceUrls(newServiceUrls);
  };

  return (
    <>
      <div>
        <table className="profile-inputs">
          <tbody>
            {Object.entries(serviceUrls[serviceName]).map(([key, value]) => (
              <tr key={key}>
                <td>
                  <label htmlFor={key}>{key}: </label>
                </td>
                <td>
                  <input
                    contentEditable={true}
                    placeholder="Enter value"
                    type="text"
                    id={key}
                    defaultValue={
                      ["x-client-code", "url", "redirectUrl"].includes(key)
                        ? ""
                        : editableFields[key]
                    }
                    onChange={(e) => handleChangeForServiceUrls(e, key)}
                  />
                </td>
                <td>
                  <CircleMinus
                    size={20}
                    strokeWidth={1}
                    color={"red"}
                    onClick={() => handleDeleteRow(key)}
                  />
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <input
                  style={{ width: "120px" }}
                  placeholder="Enter new key"
                  type="text"
                  value={newKey}
                  onChange={(e) => setNewKey(e.target.value)}
                />
              </td>
              <td>
              <CirclePlus
                  size={35}
                  strokeWidth={1}
                  color={"#23c6b0"}
                  onClick={handleAddNewDiv}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
